import { axios } from "..";
import { ContentType, IContent } from "../interfaces";

export const getFilteredContents = async (
  fields: any,
  filter: any,
  pagination: any,
  sort: any
) => {
  try {
    const queryString = `/content?fields=${JSON.stringify(fields)}
      &filter=${JSON.stringify(filter)}
      &pagination=${JSON.stringify({ ...pagination, pageNumber: pagination.pageNumber - 1 })}
      &sorting=${JSON.stringify(sort)}`;
    const response = await axios.Get(queryString);
    const dataToAdd = response.data;
    if (dataToAdd != null) {
      return dataToAdd;
    }
  } catch (error) {
    console.error("Error al obtener la información de la columna:", error);
  }
};

export const countContents = async (filter: any, count: boolean = true) => {
  try {
    const queryString = `/content?count=${count.toString()}
    &filter=${JSON.stringify(filter)}`;
    const response = await axios.Get(queryString);
    const dataToAdd = response.data;
    if (dataToAdd != null) {
      return dataToAdd;
    }
  } catch (error) {
    console.error("Error al obtener la información de la columna:", error);
  }
};

/** Same visibility rules as MyWSG press/articles: approved, published, linked to firm. */
export const countFirmPublishedContents = async (
  firmId: string,
  contentType: ContentType,
): Promise<number> => {
  const normalizedFirmId = firmId.trim();
  if (!normalizedFirmId) {
    return 0;
  }

  try {
    const filter = {
      publishedDate: { value: "pending", comparisonType: "NOT_EQUAL" },
      contentType: { value: contentType, comparisonType: "EQUAL" },
      isApproved: { value: "yes", comparisonType: "EQUAL" },
      memberFirms: {
        value: normalizedFirmId,
        comparisonType: "ARRAY_CONTAINS",
      },
    };
    const result = await countContents(filter);
    if (Array.isArray(result) && result.length > 0) {
      const count = Number(result[0]);
      return Number.isFinite(count) ? count : 0;
    }
    const single = Number(result);
    return Number.isFinite(single) ? single : 0;
  } catch (error) {
    console.error("Error counting firm contents:", error);
    return 0;
  }
};

export const countUniqueMembersAuthors = async (filter = {}) => {
  try {
    const queryString = `/content?uniqueMemberAuthors=true
      &filter=${JSON.stringify(filter)}`;
    const response = await axios.Get(queryString);
    const dataToAdd = response.data;
    if (dataToAdd != null) {
      return dataToAdd;
    }
  } catch (error) {
    console.error("Error al obtener la información de la columna:", error);
  }
};

export const countFirmsWithArticles = async (filter = {}) => {
  try {
    const queryString = `/content?totalFirmWithArticles=true
    &filter=${JSON.stringify(filter)}`;
    const response = await axios.Get(queryString);
    const dataToAdd = response.data;
    if (dataToAdd != null) {
      return dataToAdd;
    }
  } catch (error) {
    console.error("Error al obtener la información de la columna:", error);
  }
};

export const deleteContent = async (id: string) => {
  try {
    const response = await axios.Delete(`/content`, `${id}`);
    return response.status === 200;
  } catch (error) {
    console.error(error);
    throw error
  }
};

export const updateContent = async (content: IContent) => {
  try {
    const response = await axios.Put(`/content`, content);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error
  }
};

export const createContent = async (content: IContent) => {
  try {
    const response = await axios.Post(`/content`, content);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error
  }
};

export const getLastContents = async (limit: number, contentType: ContentType, firmId?: string): Promise<IContent[]> => {
  try {
    const params = new URLSearchParams();
    const filter: any = {
      publishedDate: {value: 'pending', comparisonType: 'NOT_EQUAL'},
      contentType: {value: contentType, comparisonType: 'EQUAL'},
      isApproved: {value: 'yes', comparisonType: 'EQUAL'}
    };
    
    if (firmId) {
      filter.memberFirms = {value: firmId, comparisonType: 'ARRAY_CONTAINS'};
    }
    
    params.append('filter', JSON.stringify(filter));
    params.append('pagination', JSON.stringify({pageIndex: 0, pageSize: limit}));
    params.append('sort', JSON.stringify({field: 'publishedDate', order: 'DESC'}));
    
    const response = await axios.Get(`./content?${params.toString()}`);
    
    if (!response?.data) {
      return [];
    }
    
    if (!Array.isArray(response.data)) {
      return [];
    }
    
    return response.data;
  } catch (error: any) {
    console.error('Error in getLastContents:', error);
    throw error
  }
}

export const getContentsByFirmAndType = async (firmId: string, contentType:ContentType, max?: number) => {
  try {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify({
      memberFirms: {value: firmId},
      contentType: {value: contentType, comparisonType: 'EQUAL'},
    }))
    if (max) {
      params.append('pagination', JSON.stringify({pageIndex: 0, pageSize: max}))
      params.append('sort', JSON.stringify({field: 'publishedDate', order: 'desc'}))
    }
    
    const response = await axios.Get(`./content?${params.toString()}`);
    return response.data
  } catch (error) {
    throw error
  }
}